import { parseSignatureRequest } from '../../../utils/documentParserGQL';

export default (documents, currentOrganization, user) => documents.map(d => ({
  ...parseSignatureRequest(d, currentOrganization, user),
  sendReminder: true,
  type: 'outForSignature',
}));
